export interface WriteTarget {
    collection: string;
    id: string;
    patch: unknown[];
}

type RootDispatch = (type: string, payload: unknown, options: { root: boolean }) => Promise<unknown>;

/**
 * Carries the operations that failed to send. Callers that commit optimistically
 * cannot rebuild them by re-diffing, so the patch has to survive the rejection.
 */
export class CollectionWriteError extends Error {
    readonly target: WriteTarget;
    readonly cause: unknown;

    constructor(target: WriteTarget, cause: unknown) {
        super(`Could not save ${target.collection}/${target.id}`);
        this.name = 'CollectionWriteError';
        this.target = target;
        this.cause = cause;
    }
}

export async function sendUpdate(dispatch: RootDispatch, target: WriteTarget): Promise<unknown> {
    try {
        return await dispatch('collections/update', target, { root: true });
    } catch (error) {
        throw new CollectionWriteError(target, error);
    }
}
